export default __webpack_public_path__ + "static/media/light-cronos.b332f320.png";